import { getModules } from '../config/modules';
import amaLog from '../helpers/log';

let prerollReported = false;
let videoStatsInitialized = false;

export const videostats = (): void => {

  const { useVideoStats } = getModules();

  if (!useVideoStats || videoStatsInitialized) return;

  videoStatsInitialized = true;

  const maxRetries = 30;
  const retryDelay = 500;
  let attempts = 0;
  let videoRequestListener: Function | undefined;

  const tryAttachAdEvents = () => {
    if (typeof window === 'undefined' || typeof window.jwplayer !== 'function') {
      return;
    }
    const player = window.jwplayer();

    if ( typeof player?.on !== 'function' || typeof player.getState !== 'function' || !player.getState()) {
      return retry();
    }
    attachListeners(player);
  };

  const attachListeners = (player: any) => {
    amaLog('videostats attachListener');

    videoRequestListener = (response: any) => {

      amaLog('videostats window.jwplayer().on(adRequest ) listener called');

      if (prerollReported) {
        return;
      }

      try {
        const adStatObj = {
          placement: 'preroll',
          gptEvent: 'slotRequested',
        };

        if (window.ama?.adStats) {
          window.ama.adStats.add([adStatObj]);
          window.ama.adStats.push();
        }
        prerollReported = true;
        removeListener();

      } catch (error: any) {
        console.warn('Error handling ad stats:', error);
      }
    }    

    player.on('adRequest', videoRequestListener);
    const removeListener = () => {
      amaLog('videostats window.jwplayer().off(adRequest ) - listener removed');
      player.off('adRequest', videoRequestListener);
    } 
  };

  const retry = () => {
    attempts++;
    if (attempts < maxRetries) {
      setTimeout(tryAttachAdEvents, retryDelay);
    } else {
      amaLog(`videostats tryAttachAdEvents failed due to max retries - timeout ${maxRetries * retryDelay} ms`);
    }
  };

  tryAttachAdEvents();
};
